module.exports = __webpack_public_path__ + "static/media/Streetlamp Effect.78a14a43.jpg";